/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Validation_Amount_IntegerInputs */

const vi_validation_amount_integer = /** @type {(inputs: Validation_Amount_IntegerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Số tiền phải là số nguyên (không thập phân)`)
};

/**

* @param {Validation_Amount_IntegerInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const validation_amount_integer = /** @type {((inputs?: Validation_Amount_IntegerInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Validation_Amount_IntegerInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_validation_amount_integer(inputs)
});